import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import news from '../updates.json';

export const VERSION = news[0].version!;

const Updates = (props) => {
  return (
    <div>
      <div className="page-title">
        <div className="container">
          <div className="column">
            <h1 id="item-category" className="iconCenter">
              <i className="icon-aperture info-custom-icon mr-2"></i>Actualizaciones
            </h1>
          </div>
        </div>
      </div>
      <div className="container padding-bottom-3x mb-1">
        <div className="card mb-3">
          <div className="card-body">
            <div className="col-xs-12 col-sm-12 col-md-12">
              <div className="row">
                <div className="accordion" id="accordionExample" style={{ width: '100%' }}>
                  {news.map((_new, i) => {
                    return (
                      <div className="accordion-item">
                        <h2 className="accordion-header" id={'heading' + i}>
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={'#collapseOne' + i}
                            aria-expanded="true"
                            aria-controls={'collapseOne' + i}
                          >
                            Versión: {_new.version}
                          </button>
                        </h2>
                        <div
                          id={'collapseOne' + i}
                          className={`accordion-collapse collapse ${i === 0 ? 'show' : ''}`}
                          aria-labelledby={'heading' + i}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <ul>
                              {_new.news.map((update) => {
                                return (
                                  <li>
                                    <div>{update.text}</div>
                                    {update.textForAdmin &&
                                      props.LoggedInData?.usuarioRol?.ur_clave == 'admin_gral' && (
                                        <div style={{ color: '#b7b7b7' }}>Detalle: {update.textForAdmin}</div>
                                      )}
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* fin del card */}
      </div>
    </div>
  );
};

export default Updates;
